export enum AuctionGuideType {
  NOMINAL = 'nominal',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  NO_DATA = 'no-data',
  PAST = 'past',
  MIB = 'mib'
};